import { render, staticRenderFns } from "./detailUnit.vue?vue&type=template&id=11cd5002&scoped=true&"
import script from "./detailUnit.vue?vue&type=script&lang=ts&"
export * from "./detailUnit.vue?vue&type=script&lang=ts&"
import style0 from "./detailUnit.vue?vue&type=style&index=0&id=11cd5002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cd5002",
  null
  
)

export default component.exports